import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Landing } from './Landing/Index';
import { fetchDataInicial, setShowBackdrop } from 'Slices/uiSlice';
import { BackdropInicio } from 'Components/Backdrop/Index';
import './Principal.css'


const Principal = () => {
    const dispatch = useDispatch();
    const showBackdrop = useSelector((state) => state.ui.showBackdrop);

    useEffect(() => {
        const load = async () => {
            dispatch(setShowBackdrop(true));
            try {
                await dispatch(fetchDataInicial());
            } finally {
                dispatch(setShowBackdrop(false));
            }
        };

        load();
    }, [dispatch]);

    return showBackdrop ? <BackdropInicio /> : <Landing />;
}

export default Principal;
